module.exports = __webpack_public_path__ + "img/transformerLeft.ae903a63.png";